import {ApiClientBase} from "./WebApiClientBase";
import {ParcelWebHttpClient} from "./ParcelWebHttpClient";
import {AuthenticationManager} from "./AuthenticationManager";
import {Router} from "@/rawdogjs/src/router";

export class TenantProfileApi extends ApiClientBase {

    constructor(
        router: Router,
        httpClient: ParcelWebHttpClient,
        authenticationManager: AuthenticationManager,
        url: string
    ) {
        super(
            '/api/tenant-profiles',
            router,
            httpClient,
            authenticationManager,
            url
        );
    }

}